import {ProductDetailContextProvider} from '../contexts/ProductDetailContext';
import {useParams} from 'react-router-dom';
import {ProductDealsContextProvider} from '../contexts/ProductDealsContext';
import React from 'react';
import {ProductDetails} from './ProductDetail';
import {ProductBreadcrumb} from './ProductBreadcrumb';
import {ProductPurchasePanel} from './ProductPurchasePanel';

export const ProductPage = () => {
  const { productCode } = useParams();

  return (
    <ProductDetailContextProvider>
      <ProductDealsContextProvider>
        <div className="container">
          <ProductBreadcrumb />

          <div className="row justify-content-center">
            <div className="col-12 col-md-6">
              <div className="shadow-sm p-2">
                <ProductPurchasePanel />
              </div>
            </div>
            <div className="col-md-6 order-md-first rounded-3">
              <ProductDetails productCode={productCode} />
            </div>
            <div className="col-12">
              
            </div>
          </div>
        </div>
      </ProductDealsContextProvider>
    </ProductDetailContextProvider>
  );
};